/**
 * The codes bill automation stores for a bill it held because of what the Billing tab already has (LB-6094). A bill
 * held for its billing was read and matched to its property in full: it waits for review, not for a property.
 */
const BILLING_HOLD_CODES = ['BillingOverlap', 'BilledCheckUnavailable'];
const ALREADY_BILLED_CODE = 'AlreadyBilled';

/** Each stored reason's code, or null for a reason stored without one. */
const codesOf = errors => (errors || []).map(error => {
  var _exec$, _exec;
  return (_exec$ = (_exec = /^\[([^\]]+)\]/.exec(String(error))) === null || _exec === void 0 ? void 0 : _exec[1]) !== null && _exec$ !== void 0 ? _exec$ : null;
});

/**
 * The title and the line under it on a bill's problem banner, by its status and, for a bill set aside or held because
 * of its billing, by the reason stored on it.
 */
export function billStatusBannerCopy(_ref) {
  let errors = _ref.errors,
    isDuplicate = _ref.isDuplicate,
    isRejected = _ref.isRejected,
    needsProperty = _ref.needsProperty;
  const codes = codesOf(errors);
  if (isDuplicate) {
    return codes.includes(ALREADY_BILLED_CODE) ? {
      title: 'This bill is a duplicate',
      intro: 'It was not processed, because its period is already billed:'
    } : {
      title: 'This bill is a duplicate',
      intro: 'It was not processed, because the company already holds it:'
    };
  }
  if (isRejected) {
    return {
      title: 'This bill is held for your review',
      intro: 'We didn’t read it, because:'
    };
  }
  if (needsProperty) {
    // Every reason has to be a billing one: any other, coded or not, is about the property.
    const heldForBilling = codes.length > 0 && codes.every(code => BILLING_HOLD_CODES.includes(code));
    return {
      title: heldForBilling ? 'This bill needs review' : 'This bill needs a property',
      intro: 'We read it, but:'
    };
  }
  return {
    title: 'This bill couldn’t be processed',
    intro: 'Here’s why:'
  };
}